import { Component } from "react";
import { compose } from "redux";

import { reportsConnector } from "../../../services/reports/connector";

class CRMReportsComponent extends Component {
  downloadFile = (urlToSend) => {
    const token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];
    let req = new XMLHttpRequest();

    req.open("GET", urlToSend, true);
    req.responseType = "blob";
    req.setRequestHeader("Authorization", "Bearer " + token);
    req.onload = () => {
      const blob = req.response;
      const fileName = fileName;
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    };

    req.send();
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h3>CRM email reports</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <input
              type="button"
              onClick={this.downloadFile.bind(
                this,
                "/api/admin/accountinfo/emails?domain=Loanstep",
                "LT_Loanstep_Emails.xlsx",
              )}
              value="All loanstep emails"
            />{" "}
            <br />
            <input
              type="button"
              onClick={this.downloadFile.bind(
                this,
                "/api/admin/accountinfo/emails?domain=Savelend",
                "LT_Savelend_Emails.xlsx",
              )}
              value="All savelend emails"
            />{" "}
            <br />
            <input
              type="button"
              onClick={this.downloadFile.bind(
                this,
                "/api/admin/accountinfo/noactiveloanemails",
                "LT_Loanstep_No_Active_Loans_Emails.xlsx",
              )}
              value="No active loan emails"
            />{" "}
          </div>
        </div>
      </div>
    );
  }
}
export default compose(reportsConnector)(CRMReportsComponent);
